import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { PageHeader, Pager, Empty, StatusPill, FieldValue } from "../components/common";

const Card = ({ l, tag }) => (
  <div className="border p-3 text-sm flex-1 min-w-[240px]">
    <div className="flex justify-between"><Link to={`/sales/leads/${l.lead_id}`} className="font-mono text-xs text-primary">{l.lead_id}</Link><span className="ax-label">{tag}</span></div>
    <div className="mt-1">{l.company_name || "—"}</div>
    <div className="text-xs text-muted-foreground">{l.contact_name} · {l.owner} · {l.source_date}</div>
    <div className="text-xs mt-1 flex gap-3"><FieldValue row={l} f="phone" /><FieldValue row={l} f="email" /></div>
    <div className="mt-2"><StatusPill code={l.status} /></div>
  </div>
);

export default function Duplicates() {
  const { can } = useAuth();
  const [page, setPage] = useState(1);
  const [d, setD] = useState({ items: [], total: 0 });
  const load = useCallback(() => api.get("/dedup", { params: { page } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), [page]);
  useEffect(() => { load(); }, [load]);
  const resolve = (rv, decision, target) => api.post(`/dedup/${rv.review_id}/resolve`, { decision, target_lead_id: target })
    .then(() => { toast.success(decision === "merge" ? "Merged" : "Kept separate"); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div>
      <PageHeader eyebrow="Data quality" title="Duplicate review" desc="Possible duplicates found by phone, email, company domain or company name. Nothing is ever merged automatically. Merging needs approval permission." />
      {!d.items.length ? <Empty text="No pending duplicate reviews." /> : d.items.map((rv) => (
        <div key={rv.review_id} className="ax-panel p-4 mb-3 no-select" data-testid={`dedup-review-${rv.review_id}`}>
          <div className="flex flex-wrap gap-3">
            <Card l={rv.lead} tag="Flagged lead" />
            {rv.candidates.map((c) => (
              <div key={c.lead_id} className="flex-1 min-w-[240px]">
                <Card l={c.lead} tag={`${c.reasons.join(", ")} · ${c.score}%`} />
                {can("sales", "approve") && <button data-testid={`dedup-merge-${rv.review_id}-${c.lead_id}`} onClick={() => resolve(rv, "merge", c.lead_id)} className="mt-2 w-full border border-primary text-primary h-8 text-xs">Merge flagged lead into {c.lead_id}</button>}
              </div>
            ))}
          </div>
          {rv.hidden_candidates > 0 && <div className="text-xs text-amber-400 mt-2">{rv.hidden_candidates} matching record(s) are outside your access. A manager can review those.</div>}
          {can("sales", "update") && <button data-testid={`dedup-keep-${rv.review_id}`} onClick={() => resolve(rv, "not_duplicate")} className="mt-3 border h-8 px-3 text-xs hover:border-primary">Not a duplicate, keep both</button>}
        </div>
      ))}
      <Pager page={d.page || 1} total={d.total} size={25} onPage={setPage} />
    </div>
  );
}
